import { defineComponent as _defineComponent } from 'vue'
import { KdButton } from 'kuaidong-ui'
import { computed, onUnmounted, ref } from 'vue'
import { IImagePopupCancelBtnParams, IImagePopupOkBtnParams } from '../models/ui'

import BaseCenterPopup from './BaseCenterPopup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImagePopup',
  props: {
    url: null,
    width: { default: 315 },
    okBtnParams: { default: null },
    cancelBtnParams: { default: null }
  },
  emits: ['ok', 'close', 'cancel', 'update:visible'],
  setup(__props: any, { emit: emits }) {

const props = __props as { url: string, width: number, okBtnParams: IImagePopupOkBtnParams | null, cancelBtnParams: IImagePopupCancelBtnParams | null };





const isOK = ref(false)

const okBtnStyle = computed(() => {
  const { top, bottom, width, height, borderRadius } = props.okBtnParams || {}

  return {
    top: top && `${top / 12}rem`,
    bottom: bottom && `${bottom / 12}rem`,
    width: width && `${width / 12}rem`,
    height: height && `${height / 12}rem`,
    borderRadius: borderRadius && typeof borderRadius === 'number' ? `${borderRadius / 12}rem` : borderRadius,
  }
})

onUnmounted(() => {
  emits('close')

  if (!isOK.value) {
    emits('cancel')
    props.cancelBtnParams?.cancalAction?.()
  }
})

function ok() {
  emits('ok')
  isOK.value = true
  emits('update:visible', false)
  props.okBtnParams?.okAction?.()
}

return { __sfc: true,props, emits, isOK, okBtnStyle, ok, KdButton, BaseCenterPopup }
}

})